/** Query param values for `GET /api/v1/influencers?window=` (matches backend InfluencersWindow). */

import { apiClient } from '../client';
import { API_ENDPOINTS } from '../endpoints';
import { withDedupe } from '@/utils/requestDedupe';
import type { InfluencersResponse } from '@/types/responses';

export const INFLUENCERS_WINDOWS = ['24h', '7d', '30d', '3m', '6m', '1y'] as const;
export type InfluencersWindow = (typeof INFLUENCERS_WINDOWS)[number];

export function isInfluencersWindow(value: string): value is InfluencersWindow {
  return (INFLUENCERS_WINDOWS as readonly string[]).includes(value);
}

export function influencersWindowCaption(window: InfluencersWindow): string {
  const labels: Record<InfluencersWindow, string> = {
    '24h': '24 hours',
    '7d': '7 days',
    '30d': '30 days',
    '3m': '3 months',
    '6m': '6 months',
    '1y': '1 year',
  };
  return labels[window];
}

export async function fetchInfluencersPage(options: {
  window: InfluencersWindow;
  page: number;
  pageSize: number;
}): Promise<InfluencersResponse> {
  const params = new URLSearchParams();
  params.set('window', options.window);
  params.set('page', String(options.page));
  params.set('page_size', String(options.pageSize));
  const url = `${API_ENDPOINTS.influencers}?${params.toString()}`;
  return withDedupe(`influencers:v1:${url}`, async () => {
    const response = await apiClient.get<InfluencersResponse>(url);
    return response.data;
  });
}
